function Footer() {
  return (
    <div>
    <div className="w-4/5 mx-auto text-gray-500 mt-36 sm:mt-20 mb-10 lg:mb-2">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-20 sm:gap-0 mx-auto">
        <div className="grid grid-cols-1 gap-6  mx-auto text-start sm:text-start max-w-96">  
          <p>
            CoinFlip, the world’s leading bitcoin ATM operator, makes it so
            flippin’ easy to buy and sell bitcoin via cash, card, or bank
            transfer.
          </p>
          <p>
            Sign up to get the latest in CoinFlip news, discounts, and more.
          </p>
          <input placeholder="Email Address" className="px-6 py-3 max-w-60  border border-gradient-to-tr from-[#933FFE] to-[#18C8FF] bg-gray-950 rounded-lg "></input>
          <p>© 2021 GPD Holdings, LLC FinCEN MSB</p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-1 gap-6  mx-auto">
            <h4>Company</h4>
            <h5>About</h5>
            <h5>Careers</h5>
            <h5>Press</h5>
            <h5>News</h5>
            <h5>Merch</h5>
        </div>
        <div className="grid grid-cols-1 gap-6  mx-auto">
            <h4 className="font-bold">Privacy Policy and terms Of Service</h4>
            <h5>CoinFlip Privacy Policy</h5>
            <h5>CoinFlip Biometrics Privacy Policy</h5>
            <h5>CoinFlip Financial Privacy Policy</h5>
            <h5>CoinFlip Terms Of Services</h5>
            <h5>CoinFlip Trade Desk Terms Of Service</h5>
            
        </div>
      </div>
    </div>
    <img src="/images/bg-gradient-green-bottom.png" alt="" className="absolute -z-20 hidden lg:block top-[745%] above-1100:top-[640%] 2xl:top-[580%]" />
    </div>
  );
}

export default Footer